<template>
  <ListingsCheckboxFilter
    v-model="proxyModelValue"
    :analytics-event="EAnalyticsEvent.DASHBOARD_FILTERS_HIDE_CONTACTS_CHANGED"
    label="Hide contacts without details?"
    explanation="These are contacts that have neither a phone number nor an email address."
  />
</template>

<script lang="ts" setup>
  // Types
  import type { WritableComputedRef } from 'vue';
  import { EAnalyticsEvent } from '~/misc/services/analytics/types';

  // Components
  import ListingsCheckboxFilter from '~/misc/listings/filters/checkbox/ListingsCheckboxFilter.vue';

  const emit = defineEmits<{
    (e: 'update:modelValue', value: boolean): void;
  }>();

  const props = defineProps({
    modelValue: {
      type: Boolean,
      default: true,
    },
  });

  const proxyModelValue: WritableComputedRef<boolean> = computed({
    get(): boolean {
      return props.modelValue;
    },
    set(value: boolean): void {
      emit('update:modelValue', value);
    },
  });
</script>
